import { lazy } from "react";

const ProfileTeacherScreen = lazy(() =>
    import("../../views/teachers/v2/session/profile/ProfileScreen")
);

const TeacherPunches = lazy(() =>
    import("../../views/teachers/v2/session/TeacherPunches")
);

const TeacherOclock = lazy(() =>
    import("../../views/teachers/v2/session/oclock/TeacherOclock")
);

const TeachersSchedule = lazy(() =>
    import("../../views/teachers/TeachersSchedule")
);

const TeacherGroupsScreen = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherGroups/TeacherGroupsScreen"
    )
);

const TeacherSubjectsScreen = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherSubjects/TeacherSubjectsScreen"
    )
);

const TeacherGroupById = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherGroups/TeacherGroupById"
    )
);

const TeacherSubjectById = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherSubjects/TeacherSubjectById"
    )
);

const TeacherExtraordinariesScreen = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/Grades/TeacherExtraordinaries/TeacherExtraordinariesScreen"
    )
);

const TeacherOrdinariesScreen = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/Grades/TeacherOrdinaries/TeacherOrdinariesScreen"
    )
);

const TeacherAttendancesScreen = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherAttendances/TeacherAttendancesScreen"
    )
);
const TeacherAttendanceBySubject = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherAttendances/TeacherAttendaceBySubject"
    )
);
const TeacherProgrammaticAdvanceScreen = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherProgrammaticAdvance/TeacherProgrammaticAdvanceScreen"
    )
);
const TeacherLoadDocumentsScreen = lazy(() =>
    import(
        "../../views/teachers/TeacherSession/Modules/TeacherLoadDocuments/TeacherLoadDocumentsScreen"
    )
);
const TeacherTechnicalSheet = lazy(() =>
    import("../../views/teachers/TeacherTechnicalSheet")
);

// Eventos académicos
const AcademicEventsScreen = lazy(() =>
    import("../../views/operators/academic_events/AcademicEventsScreen")
);

// Asistentes de eventos academicos
const AcademicEventsParticipants = lazy(() =>
    import("../../views/operators/academic_events/AcademicEventsParticipants")
);

export const TeachersRoutes = {
    ProfileTeacherScreen,
    TeacherPunches,
    TeacherOclock,
    TeachersSchedule,
    TeacherGroupsScreen,
    TeacherSubjectsScreen,
    TeacherExtraordinariesScreen,
    TeacherOrdinariesScreen,
    TeacherGroupById,
    TeacherSubjectById,
    TeacherAttendancesScreen,
    TeacherAttendanceBySubject,
    TeacherProgrammaticAdvanceScreen,
    TeacherLoadDocumentsScreen,
    TeacherTechnicalSheet,
    AcademicEventsScreen,
    AcademicEventsParticipants,
};
